import { Observable, tap } from 'rxjs';
import { ProgressTypeEnum } from '../../enums/progress-type/progress-type.enum';
import { Progress } from '../../models/progress/progress.model';

export const tapProgressPercent =
    (mapper: (percent: number) => void) =>
    <Body>(source$: Observable<Progress<Body>>) =>
        source$.pipe(
            tap((progress) => {
                if (
                    progress.type === ProgressTypeEnum.PENDING &&
                    progress.percent
                ) {
                    mapper(progress.percent);
                }
            }),
        );
